import { isTrustedOrigin } from '../src/trusted-origin'

let TODOIST_FRAME: HTMLIFrameElement | null

function init(): void {
    TODOIST_FRAME = document.getElementById('todoist_frame') as HTMLIFrameElement

    window.addEventListener('message', (e: MessageEvent) => {
        if (!isTrustedOrigin(e.origin)) {
            return
        }

        if (
            typeof e.data === 'string' &&
            (e.data.indexOf('--/--') !== -1 ||
                e.data.indexOf('GMAIL_MESSAGE_ADD') !== -1 ||
                e.data.indexOf('SHOW_QUICK_ADD') !== -1)
        ) {
            const frameOrigin = TODOIST_FRAME?.src
                ? new URL(TODOIST_FRAME.src).origin
                : 'https://app.todoist.com'
            TODOIST_FRAME?.contentWindow?.postMessage(e.data, frameOrigin)
        }
    })
}

document.addEventListener('DOMContentLoaded', () => {
    init()
})
